<template>
  <button
    :type="type"
    :disabled="disabled"
    class="cta-btn"
    :class="['flex flex-col gap-[2px]', block ? 'w-full' : 'w-auto', variantClass, sizeClass]"
    @click="$emit('click')"
  >
    <span class="title" :class="textColorClass">{{ title }}</span>
    <span class="label" :class="[textColorClass, labelSizeClass]">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'AbsolutelyCtaButton',

  props: {
    block: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'normal',
      validator: value => ['small', 'normal'].includes(value),
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'button',
    },
    variant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary'].includes(value),
    },
  },

  computed: {
    variantClass() {
      return `cta-btn--${this.variant}`;
    },

    textColorClass() {
      const colors = {
        primary: 'text-[#3d6301]',
        secondary: 'text-[#2c4e0a]',
      };
      return colors[this.variant];
    },

    sizeClass() {
      return this.size === 'small' ? 'cta-btn--small' : '';
    },

    labelSizeClass() {
      return this.size === 'small' ? 'label--small' : '';
    },
  },
};
</script>

<style scoped lang="scss">
.cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 24px;
  border: 12px solid transparent;
  border-image-slice: 30;
  border-image-width: 30;
  border-image-repeat: stretch;
  border-image-source: url('/assets/absolutely/button/green-button-border.svg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  text-transform: uppercase;
  font-weight: 700;
  box-sizing: border-box;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;

  &--secondary {
    border-image-source: url('/assets/absolutely/button/secondary-button-border.svg');
  }

  &--primary {
    position: relative;
    overflow: hidden;
  }

  &--small {
    padding: 1px 16px;
    border-image-width: 20;
  }

  &:active {
    transform: scale(0.97);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.label {
  @apply inline-block text-center w-full font-a-big-deal text-[1.125rem] md:text-[1.5rem];
  text-shadow: -1px 1px 0 rgba(255, 255, 255, 0.81);

  &--small {
    font-size: 14px;
  }
}

.title {
  display: inline-block;
  text-align: center;
  width: 100%;
  text-shadow: -1px 1px 0 rgba(255, 255, 255, 0.81);
  font-family: 'a Big Deal';
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-size: 14px;
}
</style>
